$(document).ready(function () {
  function replaceCartContentFromResponse(targetSelector, parsedDocument) {
    var target = document.querySelector(targetSelector);
    var source = parsedDocument.querySelector(targetSelector);

    if (!target || !source) return false;

    var safeSource = source.cloneNode(true);
    var scripts = safeSource.querySelectorAll('script');

    for (var scriptIndex = scripts.length - 1; scriptIndex >= 0; scriptIndex--) {
      scripts[scriptIndex].parentNode.removeChild(scripts[scriptIndex]);
    }

    while (target.firstChild) {
      target.removeChild(target.firstChild);
    }

    while (safeSource.firstChild) {
      target.appendChild(safeSource.firstChild);
    }

    return true;
  }

  function enableOutsideClickToCloseCartDrawer() {
    $(document).on('click', function (e) {
      var $cartDrawer = $('#CartDrawer');
      if ($cartDrawer.hasClass('drawer--is-open')) {
        if (!$cartDrawer.is(e.target) && $cartDrawer.has(e.target).length === 0) {
          $('html').removeClass('js-drawer-open lock-scroll');
          $cartDrawer.removeClass('drawer--is-open');
        }
      }
    });
  }
  function UpdateCartDrawer(){ 
    $.ajax({
      url: '/',
      type: 'GET',
      dataType: 'html',
      beforeSend: function() {
      }
    })
    .done(function(data) {
      $('#btn_saveaddtocart').removeClass('btn--loading');
      $('html').addClass('js-drawer-open lock-scroll');
      $('#CartDrawer').addClass('drawer--is-open');
      var parsedDocument = new DOMParser().parseFromString(data, 'text/html');
      replaceCartContentFromResponse('#CartDrawerForm', parsedDocument);
      replaceCartContentFromResponse('#CartPageForm', parsedDocument);
      updateCartItemCount();
    });
  
  }
  
  function updateCartItemCount() {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cartData) {
        var itemCount = cartData.item_count;
        if(itemCount == 0){
          $('#CartDrawer').addClass('is-empty');
        }else{
          $('#CartDrawer').removeClass('is-empty');
        }
        $('.cart-link__bubble-num').text(itemCount);
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) {
      }
    });
  } 
  function handleFreeGift() {
    if (typeof window.reconcileAutoFreeGift === 'function') {
      return window.reconcileAutoFreeGift();
    }
  }
  
  const maxLetters = 15;
  let selectedFont = 'font-arial';
  let selectedFontFront = '';
  let selectedFontBack = '';
  let selectedSide = 'front';

  const $openBtn = $('#openCartBtn');
  const $closeBtn = $('#myCloseCartBtn');
  const $cartDrawer = $('#myCartDrawer');
  const $cartOverlay = $('#myCartOverlay');
  const $tabButtons = $('.my-tab-btn');
  const $saveBtn = $('#btn_save');
  const $flipper = $('#myTabFlipper');
  const $fontButtons = $('.butnFont');
  const $engravingInputs = $('.engraving-input');
  const $cancelPopup = $('#cancelPopup');
  const $cancelBtn = $('#btn_cancel');
  const $btn_canceladdtocart = $('#btn_canceladdtocart');
  const $popupCloseBtn = $('#popupCloseBtn');
  const $popupCloseBtnaddtocart = $('#popupCloseBtnaddtocart');
  const $popupContinueBtn = $('#popupContinueBtn');
  const $popupExitBtn = $('#popupExitBtn');
  const $addToCartSlideshow = $('#addtocartslideshow');
  const $backToEditButtons = $('.backtoedit');
  const $btn_saveaddtocart = $('#btn_saveaddtocart');
  const $submitAddtocart = $('#submitAddtocart');

  const $forwardText = $('#forward_text');
  const $backwardText = $('#backward_text');
  const $forwardTextFloating = $('#forward_text_floating');
  const $backwardTextFloating = $('#backward_text_floating');

  function clearEngravingInputs() {
    $engravingInputs.val('');
    $('#forward_text, #backward_text, #forward_text_floating, #backward_text_floating').text('');
    selectedFontFront = '';
    selectedFontBack = '';
    $fontButtons.removeClass('active');
    $('.matat-addtocart_popupslide').removeClass('forward backward open');
    $('.my-tab-face').each(function () {
      $(this).find('.count-label').text(`0 / ${maxLetters}`);
      $(this).find('.warning').hide();
    });
    toggleSaveButton();
  }
  enableOutsideClickToCloseCartDrawer();
  function toggleSaveButton() {
    const hasValue = $engravingInputs.toArray().some(input => $(input).val().trim() !== '');
    if (hasValue) {
      $saveBtn.removeAttr('disabled');
    } else {
      $saveBtn.attr('disabled', 'disabled');
    }
  }

  function openDrawer() {
    $cartDrawer.addClass('open');
    $cartOverlay.show();
  }

  function closeDrawer() {
    $cartDrawer.removeClass('open');
    $cartOverlay.hide();
    $cancelPopup.removeClass("active__show").hide();
    $addToCartSlideshow.removeClass("open").hide();
    clearEngravingInputs(); 
  }

  $engravingInputs.on('input', function () {
    toggleSaveButton();
    const $input = $(this);
    const valType = $input.data('val');
    $(`#${valType}_text`).text($input.val());
    $(`#${valType}_text_floating`).text($input.val());

    const $container = $input.closest('.my-tab-face');
    const letterCount = $input.val().length;
    $container.find('.count-label').text(`${letterCount} / ${maxLetters}`);
    $container.find('.warning').toggle(letterCount >= maxLetters);
  });

  toggleSaveButton();

  $saveBtn.on('click', function () {
    const $activeTab = $('.my-tab-buttons .my-tab-btn.active');
    const tabValue = $activeTab.data('tab') || '';
    $cartDrawer.removeClass("open");
    setTimeout(function () {
      $addToCartSlideshow.show().addClass("open " + tabValue);
    }, 400);
  });

  if ($btn_saveaddtocart.length) {
    $btn_saveaddtocart.on('click', async function () {
      btn_saveaddtocart.addClass('btn--loading');
      const $forwardInput = $('.engraving-input[data-val="forward"]');
      const $backwardInput = $('.engraving-input[data-val="backward"]');
      const SECOND_PRODUCT_VARIANT_ID = $('.engraving_block').data('pro-id');
      const MAIN_PRODUCT_VARIANT_ID = $('.product-single__variants').val();
      const BOX_GIFT = $('.bundle-items input').attr('data-giftuniid');
      const checkBocSelected = $('#cdk-gift-wrap1')
      const forwardTextVal = $forwardInput.val().trim();
      const backwardTextVal = $backwardInput.val().trim();
      const groupId = Date.now().toString();
  
      if (!MAIN_PRODUCT_VARIANT_ID) {
        console.error("⚠️ Main product variant ID not found.");
        return;
      }
  
      if (!SECOND_PRODUCT_VARIANT_ID) {
        console.error("⚠️ Second (engraving) product variant ID not found.");
        return;
      }
  
      // Skip if both engravings are empty
      if (!forwardTextVal && !backwardTextVal) {
        console.log("Both engraving inputs are empty. Skipping.");
        return;
      }
  
      const items = [
        {
          id: MAIN_PRODUCT_VARIANT_ID,
          quantity: 1,
          properties: {
            timestamp: groupId
          }
        },
        {
          id: SECOND_PRODUCT_VARIANT_ID,
          quantity: 1,
          properties: {
            _auto_added: true,
            timestamp: groupId,
            ...(forwardTextVal && { "חריטה מקדימה": forwardTextVal }),
            ...(backwardTextVal && { "חריטה מאחורה": backwardTextVal })
          }
        }
      ];
      if ($('#cdk-gift-wrap1').prop('checked')== true) {
        items.push({
          id: BOX_GIFT,
          quantity: 1,
          properties: {
            timestamp: groupId
          }
        });
      }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });
  
        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.description || 'Cart add failed');
        }
        
  
        UpdateCartDrawer();       
        updateCartItemCount();
        closeDrawer();
        clearEngravingInputs();
      } catch (error) {
        console.error("❌ Failed to add both products:", error);
      }
    });
  }
  
  

  $openBtn.on('click', openDrawer);
  $closeBtn.on('click', closeDrawer);
  $cartOverlay.on('click', closeDrawer);
  $popupCloseBtnaddtocart.on('click', closeDrawer);

  $tabButtons.on('click', function () {
    $tabButtons.removeClass('active');
    $(this).addClass('active');

    const tab = $(this).data('tab');
    $flipper.toggleClass('flip', tab === 'backward');
    selectedSide = (tab === 'forward') ? 'front' : 'back';
    selectedFont = (selectedSide === 'front' ? selectedFontFront : selectedFontBack) || 'font-arial';

    if (selectedSide === 'front') {
      $('.engraving-input[data-val="backward"]').val('').trigger('input');
    } else {
      $('.engraving-input[data-val="forward"]').val('').trigger('input');
    }

    $fontButtons.removeClass('active');
    $fontButtons.filter(`[data-val="${selectedFont}"]`).addClass('active');
  });

  $cancelBtn.on('click', function () {
    $cancelPopup.show();
    $cartDrawer.removeClass('open');
    setTimeout(() => $cancelPopup.addClass("active__show"), 10);
  });

  $btn_canceladdtocart.on('click', function () {
    $addToCartSlideshow.removeClass("open").hide();
    $cancelPopup.show();
    setTimeout(() => $cancelPopup.addClass("active__show"), 10);
  });

  $popupCloseBtn.on('click', function () {
    $cancelPopup.removeClass("active__show");
    setTimeout(() => $cancelPopup.hide(), 400);
  });

  $popupContinueBtn.on('click', function () {
    $cancelPopup.removeClass("active__show");
    setTimeout(() => {
      $cancelPopup.hide();
      $cartDrawer.addClass('open');
    }, 10);
  });

  $backToEditButtons.on('click', function () {
    const dataObject = $(this).data('edit');
    $addToCartSlideshow.removeClass("open forward backward").hide();
    setTimeout(() => {
      $cartDrawer.addClass('open');
      $cartOverlay.show();
      $(`.my-tab-btn[data-tab="${dataObject === 'front' ? 'forward' : 'backward'}"]`).click();
    }, 400);
  });

  $popupExitBtn.on('click', function () {
    $cancelPopup.removeClass("active__show");
    setTimeout(() => {
      $cancelPopup.hide();
      closeDrawer();
    }, 400);
  });
  $('.product-single__variants').change(function () {
    var thisvarid = $(this).val();
    var thisVarTitle = $(this).find('option[value="' + thisvarid + '"]').attr('data-title');
  
    if (thisVarTitle == 'White') {
      $('.front-img-gold, .back-img-gold').hide();
      $('.front-img-white, .back-img-white').show();
    } else if (thisVarTitle == 'Gold') {
      $('.front-img-gold, .back-img-gold').show();
      $('.front-img-white, .back-img-white').hide();
    }
  });
  
  
});
